import { render, staticRenderFns } from "./StartupStatChart.vue?vue&type=template&id=89f4b7fe"
import script from "./StartupStatChart.vue?vue&type=script&lang=js"
export * from "./StartupStatChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports